import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Button } from './Button';

const FilterActions = ({
  onSearch,
  onClear,
  searchLabel = 'Ara',
  clearLabel = 'Temizle',
  className = '',
  compact = false,
}) => {
  const buttonClass = compact ? 'h-6 px-2 text-[10px]' : 'h-8 px-3 text-xs';
  const iconClass = compact ? 'h-2.5 w-2.5' : 'h-3.5 w-3.5';

  return (
    <div className={`flex items-center gap-1.5 ${className}`.trim()}>
      {onClear ? (
        <Button
          type="button"
          onClick={onClear}
          variant="outline"
          className={buttonClass}
        >
          {clearLabel}
        </Button>
      ) : null}

      {onSearch ? (
        <Button
          type="button"
          onClick={onSearch}
          className={`${buttonClass} bg-blue-600 hover:bg-blue-700 text-white`}
        >
          <MagnifyingGlassIcon className={iconClass} />
          {searchLabel}
        </Button>
      ) : null}
    </div>
  );
};

export default FilterActions;
